import { render } from "./CommonSpinner.vue?vue&type=template&id=bc42ebfe&scoped=true&ts=true"
import script from "./CommonSpinner.vue?vue&type=script&lang=ts"
export * from "./CommonSpinner.vue?vue&type=script&lang=ts"

import "./CommonSpinner.vue?vue&type=style&index=0&id=bc42ebfe&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc42ebfe"]])

export default __exports__